export function BootstrapCfPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Bootstrap Credit Facility</h1>
      <p className="text-muted-foreground">Bootstrap a new credit facility.</p>
    </div>
  );
}
